export default __webpack_public_path__ + "static/media/tesla-now-5.a5c8ba4e.png";